export default {
  fileTitle: 'עמלות של הסוכן {1}',
};
